var _excluded = ["className", "children", "isFlushPadding", "variant", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useRef, useEffect, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import PropTypes from 'prop-types';
import { ModalToggleContext } from '../../context/modal-context';
import StyledModalBody from './modal.body.styles';
var modalBodyPropTypes = {
  /** Child elements to be rendered inside of the modal body */
  children: PropTypes.node,
  /** Add custom CSS classes to component */
  className: PropTypes.string,
  /** To remove the left and right padding */
  isFlushPadding: PropTypes.bool,
  /** Tile Body background color */
  variant: PropTypes.oneOf(['default', 'gray', 'cool-gray']),
  /** Add utility objects for styling */
  utils: PropTypes.object
};
var modalBodyDefaultProps = {
  className: '',
  children: /*#__PURE__*/React.createElement("div", null),
  isFlushPadding: false,
  variant: 'default',
  utils: {}
};
var ModalBody = function ModalBody(props) {
  var className = props.className,
    children = props.children,
    isFlushPadding = props.isFlushPadding,
    variant = props.variant,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  var _useContext = useContext(ModalToggleContext),
    bodyId = _useContext.bodyId;
  var modalContentRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasVerticalScrollBar = _useState2[0],
    setHasVerticalScrollBar = _useState2[1];
  useEffect(function () {
    var checkForScrollBar = function checkForScrollBar() {
      var element = modalContentRef.current;
      if (element) {
        setHasVerticalScrollBar(element.scrollHeight > element.clientHeight);
      }
    };
    var resizeObserver = new ResizeObserver(function () {
      checkForScrollBar();
    });
    if (modalContentRef.current) {
      resizeObserver.observe(modalContentRef.current);
    }
    return function () {
      if (modalContentRef.current) {
        resizeObserver.unobserve(modalContentRef.current);
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledModalBody, _extends({
    id: bodyId
  }, other, {
    className: className,
    isFlushPadding: isFlushPadding,
    variant: variant,
    ref: modalContentRef
    /* tabIndex required so modal body can be focused and scrolled. */
    /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */,
    tabIndex: hasVerticalScrollBar && 0,
    utils: utils
  }), children);
};
ModalBody.propTypes = modalBodyPropTypes;
ModalBody.defaultProps = modalBodyDefaultProps;
ModalBody.displayName = 'Modal.Body';
export default ModalBody;